import React, { useState, useEffect } from "react";
import { Col, Row, Button, Form, Image } from "react-bootstrap";
import SVG from "react-inlinesvg";
import {
  NewInputText,
  NewSelectBoxInput,
} from "../../../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingMapButton,
} from "../../../../../../reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { TopTextReusableComponent } from "../../../../../../reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  FormControl,
  IconButton,
  InputAdornment,
  OutlinedInput,
  Select,
  InputLabel,
  makeStyles,
  MenuItem,
} from "@material-ui/core";
import SearchIcon from "@material-ui/icons/Search";
import { AddButtonIconComponent } from "../../../../../../../reusableComponents/buttonReusableComponent/ButtonReusableComponent";
import Scrollbars from "react-custom-scrollbars";

import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import * as yup from "yup";
import SimpleReactLightbox from "simple-react-lightbox";
import { MultipleImageUploadComponent } from "../../../../../../../reusableComponents/imageUploadReusableComponent/MultipleImageUploadComponent";
import axios from "axios";
import Alert from "react-s-alert";
import {
  serverApi,
  videoUploadSize,
} from "../../../../../.././../../config/Keys";
import PropTypes from "prop-types";
import { connect } from "react-redux";
//import {  } from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";
import {
  create_new_item_menu_setup,
  get_category_menu_setup,
  update_item_menu_setup,
} from "../../../../../../../../store/actions/VendorSubscriptionAction/vendorSubscriptionGetAction";

import {
  getCountries,
  getCountryCallingCode,
} from "react-phone-number-input/input";
import en from "react-phone-number-input/locale/en.json";

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: "100%",
    marginBottom: "1rem",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
}));

const validate = (values) => {
  const errors = {};

  if (values.food_type.length === 0) {
    errors.food_type = "Please select food type";
  }

  return errors;
};
const AddItem = (props) => {
  const classes = useStyles();
  //state
  const [errors, setErrors] = useState({});
  const [keywords, setKeywords] = useState([]);
  const [keywordsText, setKeywordsText] = useState("");
  const [state, setState] = useState({
    all_food_type: [
      { _id: 1, title: "Crustacean" },
      { _id: 2, title: "Gluten Free" },
      { _id: 3, title: "Halal" },
      { _id: 4, title: "Kosher" },
      { _id: 5, title: "Lactose Free" },
      { _id: 6, title: "Nuts Free" },
      { _id: 7, title: "Organic" },
      { _id: 8, title: "Pescatarian" },
      { _id: 9, title: "Seafood" },
    ],
    selected_food_type: [
      { _id: 3, title: "Halal" },
      { _id: 4, title: "Kosher" },
      { _id: 5, title: "Lactose Free" },
    ],
    primary_food_type: { _id: 5, title: "Lactose Free" },
    countryOrigin: "",
  });

  //const [Video, setVideo] = useState(null);
  const selecthandleChange = (e) => {
    setState({
      ...state,
      [e.target.name]: e.target.value,
    });
  };

  const onSubmit = (e) => {
    e.preventDefault();
    // props.onChange(2);

    formikStep3.handleSubmit();
  };
  const [step, setStep] = useState(1);
  const handleStepChange = (v) => setStep(v);
  /*******************************
   * Add Keywords Action
   ******************************/
  const addKeywordsAction = (e) => {
    e.preventDefault();
    let keywordsTextVr = keywordsText;
    let keywordsArr = keywords;
    if (keywordsTextVr === "") {
      errors.keywordsTextVr = "Keywords is Required";
      setErrors({
        errors: errors,
      });
    } else if (keywordsArr.some((diner) => diner === keywordsTextVr)) {
      alert("Keywords Already Exits");
    } else {
      keywordsArr.push(keywordsTextVr);
      setKeywords(keywordsArr);
      setKeywordsText("");
    }
  };

  /*************************************
   * @DESC Keywords Change Handlers
   ************************************/
  const onKeywordsChangeHandler = (e) => {
    setKeywordsText(e.target.value);
  };
  /*************************************
   * @DESC Remove Keywords Change Handlers
   ************************************/
  const removeKeywordsAction = (indexId) => (e) => {
    var data = [...keywords];
    data.splice(indexId, 1);
    setKeywords(data);
  };

  // step 1

  const [count, setCount] = useState(1);
  const [menuCategory, setMenuCategory] = useState([]);

  const onChangeMenuCategory = (category_id) => {
    formik.setFieldValue("category", category_id);
  };

  useEffect(() => {
    onChangeMenuCategory(
      props?.alreadySetMenuCategory || props?.menuCategoryItems?.category || ""
    );
  }, [props?.alreadySetMenuCategory, menuCategory]);

  const onClickStep2 = (e) => {
    e.preventDefault();
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.name) {
      let itemNameElement = document.getElementById("name");
      itemNameElement.focus();
    }
  }, [count]);
  const formik = useFormik({
    initialValues: {
      ext_id: "",
      name: "",
      category: "",
      description: "",
      ingredient_description: "",
      keywords: [],
    },
    validationSchema: yup.object({
      name: yup
        .string()
        .max(128, "Must be 128 characters or less")
        .required("Item name is required"),
      category: yup.string().required("Please select atleast one category"),
    }),

    onSubmit: (values) => {
      formik.setFieldValue("keywords", keywords);

      if (Object.entries(props.menuCategoryItems).length !== 0) {
        let selectedFoodType = props.menuCategoryItems.food_type;
        let updateFoodType = [];
        let updateSelectedFoodType = [];
        for (let i = 0; i < foodType.length; i++) {
          if (selectedFoodType.includes(foodType[i]._id)) {
            updateSelectedFoodType.push({
              title: foodType[i].title,
              _id: foodType[i]._id,
            });
          } else {
            updateFoodType.push({
              title: foodType[i].title,
              _id: foodType[i]._id,
            });
          }
        }
        setFoodType(updateFoodType);
        setSelectedFoodType(updateSelectedFoodType);
        formikStep2.setFieldValue("food_type", updateSelectedFoodType);
      }
      handleStepChange(2);
    },
  });

  const [countStep2, setCountStep2] = useState(1);

  const [cruisneType, setCrusineType] = useState([]);

  const [preperationTime, setPreperationTime] = useState([
    { id: 1, name: 5 },
    { id: 2, name: 10 },
    { id: 3, name: 15 },
    { id: 4, name: 20 },
    { id: 5, name: 25 },
    { id: 6, name: 30 },
    { id: 7, name: 35 },
    { id: 8, name: 40 },
    { id: 9, name: 45 },
    //{ id: 10, name: "Other" },
  ]);

  const onClickStep3 = (e) => {
    e.preventDefault();

    setCountStep2(countStep2 + 1);
    formikStep2.handleSubmit();
  };

  useEffect(() => {
    if (formikStep2.errors && formikStep2.errors.veg) {
      let vegNonNameElement = document.getElementById("veg");
      vegNonNameElement.focus();
    } else if (formikStep2.errors && formikStep2.errors.cuisin_type) {
      let cTypeNameElement = document.getElementById("cuisin_type");
      cTypeNameElement.focus();
    } else if (formikStep2.errors && formikStep2.errors.primary_food_type) {
      let vegNonNameElement = document.getElementById("focusPrimary");
      vegNonNameElement.focus();
    } else if (formikStep2.errors && formikStep2.errors.prepTime) {
      let prepNameElement = document.getElementById("prepTime");
      prepNameElement.focus();
    }
  }, [countStep2]);

  const vegNon = () => {
    formikStep2.setFieldValue("veg", false);
  };

  // step2

  const [foodType, setFoodType] = useState([]);

  const [selectedFoodType, setSelectedFoodType] = useState([]);

  const onClickAddFoodType = (itemName, id) => {
    //let data = formikStep2.values.food_type;
    let data = selectedFoodType;
    let updateState = [];

    for (let i = 0; i < foodType.length; i++) {
      if (foodType[i]._id !== id) {
        updateState.push({ title: foodType[i].title, _id: foodType[i]._id });
      } else {
        data.push({ title: foodType[i].title, _id: foodType[i]._id });
      }
    }
    setFoodType(updateState);
    setSelectedFoodType(data);

    // if (data.includes(itemName)) {
    //   alert("Item already added");
    // } else {
    //   data.push(itemName);
    // }

    formikStep2.setFieldValue("food_type", data);
  };

  const removeFoodType = (itemName, itemId) => {
    if (formikStep2.values.primary_food_type === itemId) {
      formikStep2.setFieldValue("primary_food_type", "");
    }

    let updateState = foodType;

    updateState.push({ title: itemName, _id: itemId });

    setFoodType(updateState);

    let data = selectedFoodType;
    data = data.filter((item) => {
      return item._id !== itemId;
    });

    setSelectedFoodType(data);

    formikStep2.setFieldValue("food_type", data);
  };

  const setPrimaryFoodType = (itemId) => {
    formikStep2.setFieldValue("primary_food_type", itemId);
  };
  const formikStep2 = useFormik({
    initialValues: {
      veg: true,
      food_type: [],
      primary_food_type: "",
      cuisin_type: "",
      prepTime: "",
    },
    validate,
    validationSchema: yup.object({
      veg: yup.string().required("Please select any one option"),
      primary_food_type: yup
        .string()
        .required("Please select primary food type"),
      cuisin_type: yup.string().required("Please select crusine type"),
      prepTime: yup.string().required("Please select preparation time"),
    }),

    onSubmit: (values) => {
      handleStepChange(3);
    },
  });

  // step 3

  /*************************************
   * @DESC Multiple Bank Details Image Upload
   ************************************/
  const bankUploadMultipleFiles = (e) => {
    // this.setState({ bankImageLoader: true });

    if (formikStep3.values.images.length + e.target.files.length > 6) {
      Alert.error(`<h4>Cannot upload  more than 6 images</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      const vendor_id = props.auth.user.VendorUser._id;
      let restaurant_name;
      if (props.onboarding.restaurant_name) {
        restaurant_name = props.onboarding.restaurant_name.split(" ").join("");
      } else {
        restaurant_name = "";
      }

      const combined = vendor_id + "_" + restaurant_name;
      const data = new FormData();
      let flag = false;
      for (let i = 0; i < e.target.files.length; i++) {
        //let allPicures = bank_informaion;
        let allPicures = formikStep3.values.images;
        allPicures.some((phone) => {
          if (
            phone.split(`${restaurant_name}-`)[1] === e.target.files[i].name
          ) {
            flag = true;
          }
        });
        if (!flag) {
          data.append("files", e.target.files[i]);
        }
      }
      if (!flag) {
        axios
          .post(`${serverApi}/upload-assets?uploadSide=${combined}`, data)
          .then((res) => {
            // let oldData = bank_informaion;
            let oldData = formikStep3.values.images;
            let newData = res.data;
            let mergedData = oldData.concat(newData);
            // setBank_Information(mergedData);
            formikStep3.setFieldValue("images", mergedData);
            Alert.success(`<h4> Image Upload Successfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          })
          .catch((err) => {
            // this.setState({ bankImageLoader: false });
            Alert.error(`<h4>${err}</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      } else {
        // this.setState({ bankImageLoader: false });
        Alert.error(`<h4>Can not upload the same image</h4>`, {
          position: "top-right",
          effect: "bouncyflip",
          beep: true,
          html: true,
          timeout: 3000,
          offset: 35,
        });
      }
    }
  };

  const bankDocMultipleRemove = (indexId) => (e) => {
    let allImages = formikStep3.values.images.filter((item, index) => {
      return index !== indexId;
    });
    formikStep3.setFieldValue("images", allImages);
    //setBank_Information(allBankDetails);
  };

  const uploadVideo = (e) => {
    if (e.target.files && e.target.files[0].size) {
      if (e.target.files[0].size > videoUploadSize) {
        alert("File is too Big");
      } else {
        //setLoading(true);
        const data = new FormData();
        data.append("file", e.target.files[0]);
        axios
          .post(`${serverApi}/upload-assets-video`, data, {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          })
          .then((res) => {
            //setLoading(false);
            Alert.success(`<h4>Video uploaded sucessfully</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });

            //setVideo(res.data[0]);
            //formik.setFieldValue("photos", res.data[0]);
            formikStep3.setFieldValue(`videos[0]`, res.data[0]);
          })
          .catch((err) => {
            Alert.error(`<h4>Error while uploading the video</h4>`, {
              position: "top-right",
              effect: "bouncyflip",
              beep: true,
              html: true,
              timeout: 3000,
              offset: 35,
            });
          });
      }
    }
  };
  const removeVideo = () => {
    formikStep3.setFieldValue(`videos[0]`, "");
  };

  const onSuccessNext = () => {
    props.onChange(2);
    window.scroll(0, 0);
  };

  const formikStep3 = useFormik({
    initialValues: {
      images: [],
      videos: [],
      upc_code: "",
      qr_code: "",
      bar_code: "",
    },
    validationSchema: yup.object({
      images: yup.array().min(1),
    }),

    onSubmit: () => {
      //props.onChange(2);

      let foodId = [];
      for (let i = 0; i < formikStep2.values.food_type.length; i++) {
        foodId.push(formikStep2.values.food_type[i]._id);
      }

      const token = props.auth.user.accessToken;
      let formData = {};
      formData = {
        ...formik.values,
        ...formikStep2.values,
        ...formikStep3.values,
      };
      formData.currentState = 1;
      formData.runingTrack = 2;
      formData.food_type = foodId;

      if (props.activeItemId.length > 2) {
        props.update_item_menu_setup(
          props.activeItemId,
          formData,
          token,
          onSuccessNext
        );
      } else {
        props.create_new_item_menu_setup(
          formData,
          token,
          onSuccessLast,
          onErrorLast
        );
      }
    },
  });

  const onSuccess = (data) => {
    let menuData = [];
    for (let i = 0; i < data.length; i++) {
      menuData.push({
        _id: data[i]._id,
        name: data[i].name,
      });
    }
    setMenuCategory(menuData);
  };

  const onSuccessLast = () => {};

  const onErrorLast = (err) => {
    if (err !== undefined) {
      Alert.error(`<h4>${err?.data?.message}</h4>`, {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  useEffect(() => {
    const token = props.auth.user.accessToken;
    props.get_category_menu_setup(token, onSuccess);
  }, []);
  // useEffect(() => {

  // }, [props.menuCategory]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.food_type.length; i++) {
      if (props.food_type[i].status === "APPROVED") {
        data.push({
          _id: props.food_type[i]._id,
          title: props.food_type[i].title,
        });
      }
    }

    setFoodType(data);
  }, [props.food_type]);

  useEffect(() => {
    let data = [];
    for (let i = 0; i < props.crusine.length; i++) {
      if (props.crusine[i].status === "APPROVED") {
        data.push({
          _id: props.crusine[i]._id,
          title: props.crusine[i].title,
        });
      }
    }
    setCrusineType(data);
  }, [props.crusine]);

  useEffect(() => {
    if (Object.entries(props.menuCategoryItems).length !== 0) {
      let data = props.menuCategoryItems;

      formik.setFieldValue("ext_id", data.ext_id);
      formik.setFieldValue("name", data.name);
      formik.setFieldValue("keywords", data.keywords);
      setKeywords(data.keywords);
      formik.setFieldValue("category", data.category);
      formik.setFieldValue("description", data.description);
      formik.setFieldValue(
        "ingredient_description",
        data.ingredient_description
      );
      formikStep2.setFieldValue("veg", data.veg);
      formikStep2.setFieldValue("primary_food_type", data.primary_food_type);
      formikStep2.setFieldValue("cuisin_type", data.cuisin_type);
      formikStep2.setFieldValue("prepTime", data.prepTime);
      formikStep3.setFieldValue("images", data.images);
      formikStep3.setFieldValue("videos", data.videos);
      formikStep3.setFieldValue("upc_code", data.upc_code);
      formikStep3.setFieldValue("bar_code", data.bar_code);
      formikStep3.setFieldValue("qr_code", data.qr_code);
    }
  }, [props.menuCategoryItems]);

  // useEffect(() => {
  //   if (Object.entries(props.menuCategoryItems).length !== 0) {
  //     let selectedFoodType = props.menuCategoryItems.food_type;
  //     let updateFoodType = [];
  //     let updateSelectedFoodType = [];
  //     for (let i = 0; i < foodType.length; i++) {
  //       if (selectedFoodType.includes(foodType[i]._id)) {
  //         updateSelectedFoodType.push({
  //           title: foodType[i].title,
  //           _id: foodType[i]._id,
  //         });
  //       } else {
  //         updateFoodType.push({
  //           title: foodType[i].title,
  //           _id: foodType[i]._id,
  //         });
  //       }
  //     }
  //     setFoodType(updateFoodType);
  //     setSelectedFoodType(updateSelectedFoodType);
  //   }
  // }, [foodType, props.menuCategoryItems]);

  return (
    <React.Fragment>
      <Form>
        {step === 1 && (
          <React.Fragment>
            <Row>
              <Col md={8}>
                <div className="mb-4">
                  <TopTextReusableComponent
                    headingText="New Item - Basic Info"
                    headingParagraph="Manage your food items"
                  />
                </div>
              </Col>
              <Col md={4} className="text-right d-flex justify-content-end">
                <button type="button" className="enCopyItems">
                  <SVG
                    width="22px"
                    height="22px"
                    src={require("../../../../../../../../assets/images/UserManagement/copy.svg")}
                  />
                  <div className="text-red f9-400 w-100">
                    Copy from Another Item From your menu
                  </div>
                </button>
              </Col>
            </Row>
            <div className="bg-gray px-3 py-2">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        name="ext_id"
                        onChange={formik.handleChange}
                        value={formik.values.ext_id}
                      />
                    </FormControl>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3">
                      Global/Chain:
                      <br />
                      Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Col> */}
              </Row>
            </div>
            <div className="pt-3">
              <AddButtonIconComponent
                buttonText="Add Items using Global / Chain Menu"
                fontIcon="fa fa-plus"
                colorCss="blue"
              />
            </div>
            <Row>
              <Col md={8} className="mt-3">
                <NewInputText
                  controlClass={"name"}
                  labelText="Item Name"
                  extraClass={`mb-3 w-100 ${
                    formik.errors.name && formik.touched.name ? "enError" : ""
                  }`}
                  name="name"
                  onChange={formik.handleChange}
                  value={formik.values.name}
                  onFocusOut={formik.handleBlur}
                />
                {formik.errors.name && formik.touched.name ? (
                  <div className="pho_14_regular text-danger">
                    {formik.errors.name}
                  </div>
                ) : null}
              </Col>
              <Col md={8} className="mt-3">
                <div className=" onboarding-restaurant-details-margin">
                  <div className="row align-items-center">
                    <div className="col-7">
                      <NewInputText
                        extraClass="mb-0"
                        name="keywordsText"
                        onChange={onKeywordsChangeHandler}
                        value={keywordsText}
                        labelText="Keywords"
                      />
                      <div className="MuiFormHelperText-root MuiFormHelperText-root Mui-error ">
                        {errors.keywordsText}
                      </div>
                    </div>
                    <div className="col-5">
                      <AddButtonIconComponent
                        buttonText="Add More Keywords"
                        onClick={addKeywordsAction}
                        fontIcon="fa fa-plus"
                        colorCss="blue"
                      />
                    </div>
                  </div>
                </div>
              </Col>
              <Col md={8} className="mt-3">
                <div className="col-12 p-0 onboarding-restaurant-details-margin">
                  <div className="enChipBox">
                    <Scrollbars style={{ width: "100%", height: 135 }}>
                      {keywords &&
                        keywords.map((data, index) => {
                          return (
                            <div className="mb-3 mr-3" key={index}>
                              <div className="keywords_button">
                                <p>{data}</p>
                                <span
                                  className="ml-2"
                                  onClick={removeKeywordsAction(index)}
                                >
                                  <SVG
                                    src={require("../../../../../../../../assets/images/UserManagement/close.svg")}
                                  />
                                </span>
                              </div>
                            </div>
                          );
                        })}
                    </Scrollbars>
                  </div>
                  <div className="opacity5 f10-400">
                    * Manage the utterances for the food item
                  </div>
                </div>
              </Col>
              <Col md={4} className="mt-3">
                <Button variant="danger">
                  <SVG
                    src={require("../../../../../../../../assets/images/UserManagement/microphone.svg")}
                    width="22px"
                    height="30px"
                  />
                </Button>
              </Col>
            </Row>
            <Form.Label className="f14-500 mb-1 mt-4">Menu Category</Form.Label>
            <div className="f10-500 opacity5 mb-3">Select Category</div>
            <div className="d-flex align-items-center">
              {menuCategory.map((menu, index) => (
                <div
                  className="position-relative"
                  key={index}
                  onClick={() => onChangeMenuCategory(menu._id)}
                >
                  <div
                    className={`mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type ${
                      formik.values.category === menu._id
                        ? "onboarding_mapbutton_reusable_active_two"
                        : ""
                    }`}
                  >
                    <div className="d-flex align-items-center">
                      <img
                        src={
                          "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                        }
                        alt="icon"
                        title="Soups"
                      />

                      <span className="para-data-icon">{menu.name}</span>
                    </div>
                  </div>
                </div>
              ))}

              {/* <div className="position-relative">
                <div
                  className={
                    "mb-3 mr-3 onboarding_mapbutton_reusable justify-content-between onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                  }
                >
                  <div className="d-flex align-items-center">
                    <img
                      src={
                        "https://amealia.s3.amazonaws.com/categoryicons/superadminCategoryicon-180-0013.png"
                      }
                      alt="icon"
                      title="Starters"
                    />

                    <span className="para-data-icon">Starters</span>
                  </div>
                </div>
              </div> */}
            </div>
            {formik.errors.category && formik.touched.category ? (
              <div className="pho_14_regular text-danger">
                {formik.errors.category}
              </div>
            ) : null}
            <Row className="mt-4">
              <Col md={8}>
                <NewInputText
                  labelText="Item Description"
                  extraClass="mb-4 w-100"
                  multiline={true}
                  rows="5"
                  name="description"
                  onChange={formik.handleChange}
                  value={formik.values.description}
                />
              </Col>
              <Col md={8}>
                <NewInputText
                  labelText="Ingredients Description"
                  extraClass="mb-4 w-100"
                  multiline={true}
                  rows="5"
                  name="ingredient_description"
                  onChange={formik.handleChange}
                  value={formik.values.ingredient_description}
                />
              </Col>
            </Row>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              {/* <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="buuton"
              /> */}
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Next"
                buttonType="button"
                onClick={(e) => onClickStep2(e)}
                // onClick={() => handleStepChange(2)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 2 && (
          <React.Fragment>
            <div className="mb-4">
              <TopTextReusableComponent
                headingText="New Item - Characteristics"
                headingParagraph="Manage your food items"
              />
            </div>
            <div className="bg-gray px-3 py-2">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput disabled value={formik.values.ext_id} />
                    </FormControl>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3">
                      Global/Chain:
                      <br />
                      Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Col> */}
              </Row>
            </div>
            <div
              className="displayItemsName f11-400 enRadius5 my-4"
              style={{ height: 50 }}
            >
              {formik.values.name}
            </div>
            <div className="f14-700 mb-3">Is this veg or Non Veg?</div>
            <div className="checkbox-bank-account justify-content-start mb-4">
              <label className="enRadioWithText small mr-3">
                <span className="f12-500">Veg</span>
                <input
                  id="veg"
                  type="radio"
                  name="veg"
                  value={true}
                  onChange={formikStep2.handleChange}
                  checked={formikStep2.values.veg}
                />
                <span className="checkmark"></span>
              </label>

              <label className="enRadioWithText small f18-500">
                <span className="f12-500">Non Veg/Egg/Other</span>
                <input
                  type="radio"
                  name="veg"
                  value={false}
                  //onChange={formikStep2.handleChange}
                  onChange={() => vegNon()}
                  checked={!formikStep2.values.veg}
                />
                <span className="checkmark"></span>
              </label>
              {formikStep2.errors.veg && formikStep2.touched.veg ? (
                <div className="pho_14_regular text-danger">
                  {formikStep2.errors.veg}
                </div>
              ) : null}
            </div>
            <div className="f14-700 mb-3">Food Type</div>
            <div className="restaurant_type_onboarding_main smallCenter">
              <div className="cuisine-main mt-0">
                <div
                  className={
                    // state.all_food_type.length > 8
                    //   ?
                    "cuisine-main-padding-border"
                    //   : ""
                  }
                >
                  <div
                    id="box-style"
                    className="cuisine-main-padding"
                    style={{ display: "flex", flexWrap: "wrap" }}
                  >
                    {foodType.map((icon, index) => (
                      <ReusableOnboardingMapButton
                        key={index}
                        classsection={
                          state.selected_food_type.includes(icon)
                            ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type "
                            : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type"
                        }
                        onClick={() => onClickAddFoodType(icon.title, icon._id)}
                        //src={icon.icon}
                        title={icon.title}
                        //   onClick={onRestaurantFoodTypeArraySelector(
                        //     icon,
                        //     index
                        //   )}
                      />
                    ))}
                  </div>
                  {formikStep2.errors.food_type ? (
                    <div className="pho_14_regular text-danger">
                      {formikStep2.errors.food_type}
                    </div>
                  ) : null}
                </div>
                {selectedFoodType.length > 0 ? (
                  <>
                    <div className="f14-700 ">
                      Out of the selections below, which one is primary?
                    </div>

                    <div className="f12-400 mb-3 opacity5">
                      Select only one of the options below as a default - this
                      is shown to the user .
                    </div>
                  </>
                ) : (
                  <> </>
                )}
                <div
                  className="cuisine-main-padding-bottom mobile-device-bottom-margin mt-4"
                  style={{ display: "flex", flexWrap: "wrap" }}
                >
                  {selectedFoodType.map((icon, index) => (
                    <ReusableOnboardingMapButton
                      key={index}
                      classsection={
                        formikStep2.values.primary_food_type === icon._id
                          ? "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_active_two onboarding_mapbutton_reusable_type"
                          : "onboarding_mapbutton_reusable onboarding_mapbutton_reusable_type onboarding_mapbutton_reusable_active"
                      }
                      //src={icon.icon}
                      title={icon.title}
                      onClick={() => setPrimaryFoodType(icon._id)}
                      displayPrimary={
                        formikStep2.values.primary_food_type === icon._id
                          ? true
                          : false
                      }
                      displayRemove={true}
                      removeButtonClick={() =>
                        removeFoodType(icon.title, icon._id)
                      }
                    />
                  ))}
                </div>

                {formikStep2.values.food_type.length !== 0 ? (
                  <div tabIndex="0" id="focusPrimary">
                    {formikStep2.errors.primary_food_type &&
                    formikStep2.touched.primary_food_type ? (
                      <div className="pho_14_regular text-danger">
                        {formikStep2.errors.primary_food_type}
                      </div>
                    ) : null}
                  </div>
                ) : (
                  <> </>
                )}
              </div>
            </div>

            <div className="f14-700 mb-3">Cuisine Type</div>
            <div className="mb-1 d-flex flex-wrap">
              {cruisneType.map((item, index) => (
                <div className="enCheckWithText small" key={index}>
                  <input
                    id="cuisin_type"
                    type="radio"
                    name="cuisin_type"
                    value={item._id}
                    onChange={formikStep2.handleChange}
                    checked={formikStep2.values.cuisin_type === item._id}
                  />
                  <label className="w-100 d-flex align-items-center justify-content-center">
                    {item.title}
                  </label>
                </div>
              ))}
            </div>

            {formikStep2.errors.cuisin_type &&
            formikStep2.touched.cuisin_type ? (
              <div className="mb-3 pho_14_regular text-danger">
                {formikStep2.errors.cuisin_type}
              </div>
            ) : (
              <div className="mb-3"> </div>
            )}
            <div className="f14-700 mb-3">Preparation Time</div>
            <div className="mb-1 d-flex flex-wrap">
              {preperationTime.map((item, index) => (
                <div className="enCheckWithText small" key={index}>
                  <input
                    id="prepTime"
                    type="radio"
                    name="prepTime"
                    value={item.name}
                    onChange={formikStep2.handleChange}
                    checked={formikStep2.values.prepTime == item.name}
                  />
                  <label className="w-100 d-flex align-items-center justify-content-center">
                    {item.name} Minutes
                  </label>
                </div>
              ))}
            </div>
            {formikStep2.errors.prepTime && formikStep2.touched.prepTime ? (
              <div className="mb-3 pho_14_regular text-danger">
                {formikStep2.errors.prepTime}
              </div>
            ) : (
              <div className="mb-3"> </div>
            )}
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(1)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Next"
                buttonType="button"
                //onClick={() => handleStepChange(3)}
                onClick={(e) => onClickStep3(e)}
              />
            </div>
          </React.Fragment>
        )}
        {step === 3 && (
          <React.Fragment>
            <div className="mb-4">
              <TopTextReusableComponent
                headingText="New Item - Images and Videos"
                headingParagraph="Manage your food items"
              />
            </div>
            <div className="bg-gray px-3 py-2">
              <Row>
                <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3" style={{ width: 140 }}>
                      Ext Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput disabled value={formik.values.ext_id} />
                    </FormControl>
                  </div>
                </Col>
                {/* <Col md={6}>
                  <div className="d-flex align-items-center">
                    <div className="f12-700 pr-3">
                      Global/Chain:
                      <br />
                      Item ID :
                    </div>
                    <FormControl
                      className={"w-100 bg-white"}
                      variant="outlined"
                    >
                      <OutlinedInput
                        endAdornment={
                          <InputAdornment position="end">
                            <IconButton edge="end">
                              <SearchIcon />
                            </IconButton>
                          </InputAdornment>
                        }
                      />
                    </FormControl>
                  </div>
                </Col> */}
              </Row>
            </div>
            <div
              className="displayItemsName f11-400 enRadius5 my-4"
              style={{ height: 50 }}
            >
              {formik.values.name}
            </div>
            <div className="f20_700_HelveticaNeue">
              Upload Images, Videos and Other Attributes
            </div>
            <Form.Group className="pt-4">
              {/* <Form.Label className="f14-500 mb-1">Upload Images</Form.Label> */}
              <div className="d-flex flex-wrap">
                {/* <div className="enUploadBox">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input
                    type="file"
                    accept=".png, .jpg, .jpeg"
                    onChange={uploadImage}
                  />
                </div>
                {file && (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => setFile(null)}
                    >
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="uploadImg"
                        title="uploadImg"
                        fluid
                      />
                    </button>
                    <Image
                      src={file}
                      alt="icon"
                      title="icon"
                      className=""
                      fluid
                    />
                  </div>
                )} */}

                <SimpleReactLightbox>
                  <MultipleImageUploadComponent
                    title="Upload Item Images"
                    smallTitle="(Upload supporting documents such as a Cancelled Cheque, Bank Statement as applicable) - You may receive a call for KYC and Confirmation"
                    onChange={bankUploadMultipleFiles}
                    //stateValue={bank_informaion}
                    stateValue={formikStep3.values.images}
                    removeImage={bankDocMultipleRemove}
                    // loader={state.bankImageLoader}
                    accept="image/gif,image/jpeg,image/jpg,image/png,.pdf"
                  />
                </SimpleReactLightbox>
              </div>
              {formikStep3.errors.images && formikStep3.touched.images ? (
                <div className="mb-3 pho_14_regular text-danger">
                  {formikStep3.errors.images}
                </div>
              ) : (
                <div className="mb-3"> </div>
              )}
            </Form.Group>
            <Form.Group className="pb-4">
              <Form.Label className="f14-500 mb-2">Upload Videos</Form.Label>
              <div className="d-flex flex-wrap">
                <div className="enUploadBox">
                  <Image
                    src={require("../../../../../../../../assets/images/UserManagement/uploadImg.svg")}
                    alt="uploadImg"
                    title="uploadImg"
                    fluid
                  />
                  <input type="file" accept=".mp4" onChange={uploadVideo} />
                </div>
                {formikStep3.values.videos.length > 0 && (
                  <div className="enIconUploaded">
                    <button
                      type="button"
                      className="enCloseButton"
                      onClick={() => removeVideo()}
                    >
                      <Image
                        src={require("../../../../../../../../assets/images/UserManagement/en_close.svg")}
                        alt="removeVideo"
                        title="removeVideo"
                        fluid
                      />
                    </button>
                    <video
                      width="100%"
                      height="100%"
                      controls
                      src={formikStep3.values.videos[0]}
                      type="video/mp4"
                    />
                  </div>
                )}
              </div>
            </Form.Group>
            <Form.Label className="f14-500 mb-3">Other Details</Form.Label>
            <Row>
              <Col md={6}>
                <NewSelectBoxInput
                  selectLabel="Country*"
                  name="country"
                  value={state.countryOrigin}
                  onChange={selecthandleChange}
                  getCountries={getCountries}
                  en={en}
                  // errorText={errors.country}
                  // errorTrue={errors.country === "" ? true : false}
                />
              </Col>
            </Row>
            <Row>
              <Col md={6}>
                <NewInputText
                  labelText="UPC Code"
                  extraClass="mb-3 w-100"
                  name="upc_code"
                  onChange={formikStep3.handleChange}
                  value={formikStep3.values.upc_code}
                />
              </Col>
              <Col md={6}>
                <NewInputText
                  labelText="Bar Code"
                  extraClass="mb-3 w-100"
                  name="bar_code"
                  onChange={formikStep3.handleChange}
                  value={formikStep3.values.bar_code}
                />
              </Col>
              <Col md={6}>
                <NewInputText
                  labelText="FSSAI Code"
                  extraClass="mb-3 w-100"
                  name="qr_code"
                  onChange={formikStep3.handleChange}
                  value={formikStep3.values.qr_code}
                />
              </Col>
            </Row>
            <div className="onboarding-map-setup-screen-autodetect-button mt-5">
              <ReusableOnboardingButton
                buttonTitle="Back Button"
                buttonClass="btn-lg btn btn-outline-secondary"
                buttonText="Back"
                buttonType="button"
                onClick={() => handleStepChange(2)}
              />
              <ReusableOnboardingButton
                buttonTitle="Next Button"
                buttonClass="btn-lg btn btn-danger btn-lg ml-3 "
                buttonText="Save and Next"
                buttonType="button"
                onClick={(e) => onSubmit(e)}
              />
            </div>
          </React.Fragment>
        )}
      </Form>
    </React.Fragment>
  );
};

AddItem.propTypes = {
  auth: PropTypes.object.isRequired,
  create_new_item_menu_setup: PropTypes.func.isRequired,
  get_category_menu_setup: PropTypes.func.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  errors: state.errors.errors,
  onboarding: state.onboarding.restaurantDetails,
  menuCategory: state.onboarding.menuCategory,
  food_type: state.category.foodtype,
  crusine: state.category.cusine,
  menuCategoryItems: state.onboarding.menuCategoryItems,
  activeItemId: state.onboarding.activeItemId,
});

export default connect(mapStateToProps, {
  get_category_menu_setup,
  create_new_item_menu_setup,
  update_item_menu_setup,
})(AddItem);
